module.exports = __webpack_public_path__ + "img/other_1plus1.d01077a4.jpg";